import type { ClientApp } from "target_wasm";
import { useBoundStore } from "@/components/canvas/stores/useAppStore";
import type { FocusedCell } from "@/components/canvas/IFocus";
import type { RowInspectorAttachment } from "./attachmentCell";
import { parseDescriptor, type StoredDescriptor } from "@/lib/api/attachments";
import { openAttachmentViewer } from "./viewer/useAttachmentViewerStore";

/** Space on a selected Attachment cell, as the shortcut sheet names it. */
export const VIEW_FILE_SHORTCUT = "View File";

/** The stored files of an Attachment cell; none for any other cell. */
export function cellFiles(
  clientApp: ClientApp,
  cell: FocusedCell,
): StoredDescriptor[] {
  try {
    if (clientApp.table_attachment_column_id(cell.table_id) !== cell.column_id)
      return [];
    const attachment = JSON.parse(
      clientApp.row_attachment(cell.table_id, cell.row_id),
    ) as RowInspectorAttachment | null;
    return (attachment?.descriptors ?? [])
      .map(parseDescriptor)
      .filter((d): d is StoredDescriptor => d?.kind === "stored");
  } catch {
    return [];
  }
}

/** Opens the viewer on the selected cell's files; false when it holds none. */
export function viewFocusedCellFiles(): boolean {
  const { clientApp, focusedCell } = useBoundStore.getState();
  if (!clientApp || !focusedCell) return false;
  const files = cellFiles(clientApp, focusedCell);
  if (files.length === 0) return false;
  openAttachmentViewer({ tableId: focusedCell.table_id, files, index: 0 });
  return true;
}
